import moment from 'moment-timezone';

import { Contract } from './contract';
import { User } from './user';

export class ContractAlert {
	public id: number;
	public contractId: string;
	public subject: string;
	public seenDate: Date | string;
	public seenUserId: string;
	public createdAt: Date | string;

	public contract: Contract;
	public seenUser: User;

	public dismissing = false;

	constructor(contractAlert?: ContractAlert) {
		Object.assign(this, contractAlert);

		this.seenDate = this.seenDate ? new Date(moment(this.seenDate).format('MMM DD, YYYY hh:mm:ss a')) : this.seenDate;
		this.createdAt = this.createdAt ? new Date(moment(this.createdAt).format('MMM DD, YYYY hh:mm:ss a')) : this.createdAt;
		this.contract = this.contract ? new Contract(this.contract) : this.contract;
		this.seenUser = this.seenUser ? new User(this.seenUser) : this.seenUser;
	}
}
